export default __webpack_public_path__ + "static/media/ic_cameroon.158ce784.svg";